import { React, useRef, useEffect, useState } from 'react';
import { authAxios } from '../../utils';
import {accessWarehouseUrl, setCurrWarehouseUrl} from '../../constants';

//"1123 tasman Dr, sunnyvale, CA, 94089",
//"2450 S El Camino Real, San Mateo, CA, 94404"
const Warehouse = ({callback}) => {
    const [warehouses, setWarehouses] = useState([]);
    const [selected, setSelected] = useState(-1);
    const addrRef = useRef("");
    const nameRef = useRef("");
    
    useEffect(()=>{
       authAxios.get(accessWarehouseUrl)
       .then(response => {
            setWarehouses(response.data);
            let whs = [];
            for (var i=0; i<response.data.length; i++) {
                whs.push({name: response.data[i].name, coordinate: {lat: parseFloat(response.data[i].addr.lat), lng: parseFloat(response.data[i].addr.lng)}});
            }
            callback(whs);
       })
       .catch(err=>console.log(err)); 
    }, []);

    const handleAdd = () => {
        authAxios.post(accessWarehouseUrl, {addr: addrRef.current.value, name: nameRef.current.value})
        .then(res=>{
            let wh = [...warehouses];
            wh.push(res.data);
            setWarehouses(wh);
        })
        .catch(err=>{
            addrRef.current.value = err.response.data;
        });
    }
    const handleDelete = () => {
        if (selected === -1) return;
        authAxios.delete(accessWarehouseUrl+selected.toString()+"/")
            .then(res=> {
                const whs = warehouses.filter(wh=>wh.id !== selected);
                setWarehouses(whs);
            })
            .catch(err=>console.log(err));  
    }

    const handleSelect = e => {
        setSelected(parseInt(e.target.value));
        if (parseInt(e.target.value) === -1) return;
        authAxios.post(setCurrWarehouseUrl+e.target.value+"/")
        .then(res => console.log(res.data))
        .catch(err => console.log(err.response.data));
    }

  return (
    <div class="flex flex-col w-full gap-2">
        <input class="default_input default_text" placeholder='Warehouse Name' ref={nameRef}/>
        <input class="default_input default_text" placeholder='123 onion st, milpitas, CA, 95035' ref={addrRef}/>
        <button class="default_btn" onClick={()=>handleAdd()}>Add Warehouse</button>
        <select value={selected} onChange={e=>handleSelect(e)} class="default_select">
            <option value={-1}>-- Select a warehouse --</option>
            {warehouses.map((warehouse, i) => <option key={i} value={warehouse.id}>{warehouse.name+" ("+warehouse.addr.city.toLowerCase()+")"}</option>
            )}
        </select>
        <button class="default_btn" onClick={()=>handleDelete()}>Delete Warehouse</button>
    </div>
  )
}

export default Warehouse